import type { ApplyUpdate } from '../sw/register';
import './UpdateBanner.css';

/**
 * Update prompt (cue-forge-kxt.2): shown when the service worker has a newer
 * version installed and waiting. Clicking Reload activates it and refreshes.
 * `apply` is null when no update is pending (renders nothing).
 */
export function UpdateBanner({ apply }: { apply: ApplyUpdate | null }) {
  if (!apply) return null;
  return (
    <div className="cf-update" role="status" aria-live="polite">
      <span className="cf-update__msg">A new version of CueForge is available.</span>
      <button type="button" className="cf-btn cf-update__btn" onClick={apply}>
        Reload to update
      </button>
    </div>
  );
}
